import React, { useState } from "react";
import { useParams, Link } from "react-router-dom";
import axiosInstance from "../api/axiosInstance";
import { toast } from "../lib/toast";

export default function ResetPassword() {
  const { uid, token } = useParams();
  const [password1, setPassword1] = useState("");
  const [password2, setPassword2] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password1 !== password2) {
      setError("Passwords do not match.");
      toast.error("Passwords do not match.");
      return;
    }
    if (password1.length < 8) {
      setError("Password must be at least 8 characters.");
      toast.error("Password must be at least 8 characters.");
      return;
    }
    setLoading(true);
    setError("");
    try {
      await axiosInstance.post("/api/auth/password/reset/confirm/", {
        uid,
        token,
        new_password1: password1,
        new_password2: password2,
      });
      setSuccess(true);
      toast.success("Password reset successfully.");
    } catch (err) {
      const data = err.response?.data;
      if (data?.token || data?.uid) {
        setError("This reset link is invalid or has expired. Please request a new one.");
        toast.error("This reset link is invalid or has expired.");
      } else if (data?.new_password2) {
        setError(data.new_password2[0]);
        toast.error(data.new_password2[0]);
      } else if (data?.new_password1) {
        setError(data.new_password1[0]);
        toast.error(data.new_password1[0]);
      } else {
        setError("Something went wrong. Please try again.");
        toast.error("Failed to reset password. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 dark:bg-gray-900">
      <div className="bg-white dark:bg-gray-800 shadow-md dark:shadow-gray-900/50 rounded px-10 py-8 max-w-md w-full">
        <h2 className="type-page-title mb-2 text-center text-blue-600 dark:text-blue-400">Set New Password</h2>

        {success ? (
          <div className="text-center">
            <p className="type-body mb-4">
              Your password has been reset successfully.
            </p>
            <Link
              to="/login"
              className="inline-block bg-blue-500 text-white px-6 py-2 rounded hover:bg-blue-600 transition"
            >
              Log In
            </Link>
          </div>
        ) : (
          <>
            <p className="type-muted text-center mb-6">
              Enter your new password below.
            </p>

            {error && <p className="text-red-500 mb-4 text-sm text-center">{error}</p>}

            <form onSubmit={handleSubmit} className="space-y-4">
              <div>
                <label className="block text-gray-700 dark:text-gray-300">New Password</label>
                <input
                  type="password"
                  className="w-full px-4 py-2 mt-1 border dark:border-gray-600 rounded-md dark:bg-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-400"
                  value={password1}
                  onChange={(e) => setPassword1(e.target.value)}
                  required
                  autoFocus
                />
              </div>

              <div>
                <label className="block text-gray-700 dark:text-gray-300">Confirm Password</label>
                <input
                  type="password"
                  className="w-full px-4 py-2 mt-1 border dark:border-gray-600 rounded-md dark:bg-gray-700 dark:text-white focus:outline-none focus:ring-2 focus:ring-blue-400"
                  value={password2}
                  onChange={(e) => setPassword2(e.target.value)}
                  required
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600 disabled:opacity-40 transition"
              >
                {loading ? "Resetting..." : "Reset Password"}
              </button>
            </form>

            <p className="type-muted mt-4 text-center">
              <Link to="/login" className="text-blue-600 hover:underline">
                Back to login
              </Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
